var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 20 20"}},[_c('use',{attrs:{"xlink:href":'/icon/icons.svg' + _vm.href}})])
}
var staticRenderFns = []

export { render, staticRenderFns }